import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    GetUnifiedGroupsSettingsJsonResponse,
    UnifiedGroupsSettingsResponseShape,
    getServiceAsync,
} from '../../../../service';
import { runOwsRequestWithMonitor, Feature, fullResponseOperationOption } from '../../../../shared';

export function createGroupsSettingsRequest(): Promise<GetUnifiedGroupsSettingsJsonResponse> {
    return getServiceAsync().then(service =>
        service.Operation.getUnifiedGroupsSettingsOperation(
            {
                Header: getJsonRequestHeader(),
                Body: service.Factory.GetUnifiedGroupsSettingsRequest({
                    ResponseShape: UnifiedGroupsSettingsResponseShape.Basic,
                }),
            },
            fullResponseOperationOption
        )
    );
}

export default function getGroupsSettings(): Promise<GetUnifiedGroupsSettingsJsonResponse> {
    return runOwsRequestWithMonitor({
        scenarioName: 'GetUnifiedGroupsSettings',
        feature: Feature.UnifiedGroups,
        operation: () => createGroupsSettingsRequest(),
        transformResponse: (owsResponse: GetUnifiedGroupsSettingsJsonResponse) => owsResponse,
    });
}
